<template>
  <accordion-item-fi
    v-if="hasTextList || videoFields"
    :class="{
      'accordion-benefits-description-fi': true,
      'accordion-benefits-description-fi--is-detail-page': isDetailPage,
    }"
    header-tag="h3"
    ignore-others
    scroll-to
  >
    <template #header>
      <template v-if="isFite">
        {{ $dict.get('product-Catalog.Accordions.Product-Description') }}
      </template>
      <template v-else>
        {{ $dict.get('product-Catalog.Accordions.Benefits-And-Description') }}
      </template>
    </template>
    <template #content>
      <grid-columns-fi
        :columns="12"
        grid-class="lg:fi-grid-cols-10"
      >
        <div
          :class="{
            'fi-col-span-12 md:fi-col-span-8 md:fi-pr-24 lg:fi-col-span-6': videoFields,
            'fi-col-span-12 lg:fi-col-span-10': !videoFields,
          }"
        >
          <div
            v-if="isDetailPage && !isFite"
            class="accordion-benefits-description-fi__text accordion-benefits-description-fi__text--claim"
          >
            {{ textListValue(textList, 'DOKBSTMARKCLAIM') }}
          </div>

          <richtext-fi
            v-if="textListValue(textList, 'KAT_VORTEILNUTZEN')"
            :class="{
              'accordion-benefits-description-fi__text': true,
              'accordion-benefits-description-fi__text--no-spacings': isDetailPage,
            }"
            :html-content="{ value: textListValue(textList, 'KAT_VORTEILNUTZEN') }"
          />

          <richtext-fi
            v-if="textListValue(textList, 'DOKBSTMARKDESCR') && isDetailPage"
            :class="{
              'accordion-benefits-description-fi__text': true,
            }"
            :html-content="{ value: textListValue(textList, 'DOKBSTMARKDESCR') }"
          />

          <div
            v-if="!isSM && videoFields"
            class="accordion-benefits-description-fi__video fi-mt-48"
          >
            <video-player-fi
              :fields="videoFields"
              :overlay-breakpoints="overlayBreakpoints"
              :unlimited="585"
              :aspect-ratio="16 / 9"
              do-not-replace-url
              no-youku-player
            />
          </div>

          <richtext-fi
            v-if="textListValue(textList, 'EIGENSCHAFTENGEN')"
            class="accordion-benefits-description-fi__text"
            :html-content="{ value: textListValue(textList, 'EIGENSCHAFTENGEN') }"
          />
        </div>

        <div
          v-if="isSM && videoFields"
          class="accordion-benefits-description-fi__video fi-col-span-12 md:fi-col-span-4"
        >
          <video-player-fi
            :fields="videoFields"
            :overlay-breakpoints="overlayBreakpoints"
            :unlimited="585"
            :aspect-ratio="16 / 9"
            do-not-replace-url
            no-youku-player
          />
        </div>
      </grid-columns-fi>
    </template>
  </accordion-item-fi>
</template>

<script>
import { AccordionItemFi, RichtextFi } from 'atoms';

import GridColumnsFi from '@/components/grid-fi/GridColumnsFi.vue';
import VideoPlayerFi from '@/components/video-player-fi/VideoPlayerFi.vue';
import breakpointMixin from '@/mixins/breakpointMixin.vue';
import catalogMixin from '@/mixins/catalogMixin.vue';

export default {
  name: 'AccordionBenefitsDescriptionFi',
  components: {
    GridColumnsFi,
    RichtextFi,
    AccordionItemFi,
    VideoPlayerFi,
  },
  mixins: [breakpointMixin, catalogMixin],
  props: {
    catalogData: {
      type: Object,
      default: () => ({}),
    },
    isDetailPage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    overlayBreakpoints() {
      return [
        {
          mediaWidth: 320,
          imageWidth: 443,
        },
        {
          mediaWidth: 480,
          imageWidth: 731,
        },
        {
          mediaWidth: 768,
          imageWidth: 963,
        },
        {
          mediaWidth: 1024,
          imageWidth: 428,
        },
      ];
    },
    textList() {
      return this.catalogData?.TextList;
    },
    hasTextList() {
      return (
        this.textListValue(this.textList, 'KAT_VORTEILNUTZEN') ||
        this.textListValue(this.textList, 'EIGENSCHAFTENGEN') ||
        (this.isFite && this.textListValue(this.textList, 'DOKBSTMARKDESCR'))
      );
    },
    videoFields() {
      if (this.catalogData?.Media?.length) {
        const item = this.catalogData.Media.find(
          (mediaItem) => mediaItem.videoId && mediaItem.Type === 'Video' && mediaItem.Url,
        );

        if (item) {
          return {
            videoYoutubeLink: {
              value: {
                href: `https://www.youtube.com/watch?v=${item.videoId}`,
                url: `https://www.youtube.com/watch?v=${item.videoId}`,
                text: 'Youtube Video',
                altTitle: 'Youtube Video',
              },
            },
            image: {
              value: {
                src: item.Url,
                alt: 'Youtube Video',
              },
            },
          };
        }
      }

      return null;
    },
  },
};
</script>

<style src="./accordion-benefits-description-fi" />
